// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiDialog-root.PopupContainer .MuiDialog-container .MuiPaper-root {
    background-color: #2D3055;
    padding: 30px 40px 30px 30px;
    width: 100%;
    border-radius: 8px;
}
.MuiDialog-root.signinPopup .MuiDialog-container .MuiPaper-root {
    background: linear-gradient(135deg, #2D3055 0%, #252847 100%);
    border-radius: 12px;
    max-width: 400px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    overflow: visible;
}
 
/* Optional: Add a subtle animation */
.MuiDialog-root.signinPopup .MuiDialog-container .MuiPaper-root {
    animation: slideIn 0.3s ease-out;
}
 
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translate(0);
    }
}

.MuiDialog-root.PopupContainerGallery .MuiDialog-container > .MuiPaper-root {
  background-color: #2D3055;
  padding: 10px 0px;
  max-width: 80%;
  border-radius: 8px;
  height: 100%;
}
.aiInfluncerContainer{
        background-color: #292B49;
        border-radius: 8px;
}   

.MuiBox-root.PopupContent {
    display: flex;
    gap: 10px;
    flex-direction: column;
    width: 100%;
}

.MuiBox-root.PopupContentLeft {
    background-color: #292B49;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    border-radius: 8px;
    height: inherit;
}

.MuiBox-root.PopupContentLeftHeader {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
}

.PopupContentLeftHeaderTitle {
    display: flex;
    gap: 10px;
    align-items: center;
}

.MuiTypography-root.PopupTitle {
    font-size: 16px;
    font-weight: 400;
    font-family: var(--font-family-primary);
    color: #E4E5ED;
}
.MuiPaper-root.model-cards{
    width: 100%;
    padding: 10px;
}

.MuiBox-root.PopupContentRight {
    /* background-color: #292B49; */
    height: 588px;
    border-radius: 8px;
}

.MuiBox-root.PopupContentRight .MuiPaper-root {
    padding: 0px !important;
    background-color: #292B49 !important;
}

.MuiBox-root.PopupContentRightCard {
    padding: 0px;
}

.MuiBox-root.videoWrappers {
    width: 100%;
    height: 100%;
}
.MuiBox-root.ImageContainers{
    height: 200px;
    width: 100%;
}

.videoPlayer {
    height: 478px;
}

.videoPlayer {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.videoCard {
    border-radius: 12px;
    overflow: hidden;
}

.MuiBox-root.videoHeader {
    position: absolute;
    top: 8px;
    right: 4%;
}
.MuiBox-root.viewHeader{
    position: absolute;
    top: 0;
    right: 8%;
    z-index: 1;
}
.MuiBox-root.shareHeader{
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
}
.MuiBox-root.PopupHeader{
    position: absolute;
    top: 0;
    right: 0;
}
.PromptImage{
    /* width: 73%; */
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
    cursor: pointer;
}
.outPutImage{
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
    cursor: pointer;
}
.fullImage{
    width: 100%;
    height: auto;
    max-height: 80vh;
    display: block;
    margin: auto;
    object-fit: contain;
}
.MuiButtonBase-root.CloseButton{
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
}
.MuiButtonBase-root.MuiCheckbox-root.selectionCheckbox{
  position: absolute;
  top: 8px;
  right: 8px;
  border-radius: 50%;
  background-color: transparent;
}
.MuiBox-root.width100{
    width: 100%;
}
.MuiBox-root.endButton{
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}
.silderImage{
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
    background-color: #2D3055;
}
.MuiTypography-root.confirmTitle{
    font-size: 20px;
    font-weight: 400;
    font-family: var(--font-family-primary);
    color: #fff;
}
.MuiTypography-root.confirmDescription{
    font-size: 16px;
    font-weight: 400;
    font-family: var(--font-family-primary);
    color: #fff;
    margin-top: 10px;
}
.AudioPlayer.rhap_container{
    background-color: transparent;
}
.AudioPlayer>.rhap_main>.rhap_progress-section>.rhap_current-time{
    color: #fff;
}
.AudioPlayer>.rhap_main>.rhap_progress-section>.rhap_time {
    color: #fff;
}
.AudioPlayer>.rhap_main>.rhap_progress-section>.rhap_progress-container>.rhap_progress-bar{
    color: #fff;
}
.AudioPlayer>.rhap_main>.rhap_progress-section>.rhap_progress-container>.rhap_progress-bar>.rhap_progress-indicator{
    background-color: #692AA5;
    box-shadow: none;
}
.AudioPlayer>.rhap_main>.rhap_progress-section>.rhap_progress-container>.rhap_progress-bar>.rhap_progress-filled{
    background-color: #692AA5;
}
.AudioPlayer>.rhap_main>.rhap_controls-section>.rhap_additional-controls{
    display: none;
}
.AudioPlayer>.rhap_main>.rhap_controls-section{
    display: block;
}
.AudioPlayer>.rhap_main>.rhap_controls-section>.rhap_main-controls>.rhap_button-clear{
   background-color: transparent;
   font-size: 30px;
    width: 30px;
    height: 30px;
}
.AudioPlayer>.rhap_main>.rhap_controls-section>.rhap_volume-controls{
    display: none;
}
/* Responsive */
@media screen and (min-width: 768px) {
    .MuiBox-root.PopupContent {
        flex-direction: row;
    }
}

/* galaerypage */
.MuiDialogContent-root.card-gallery-content{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
}
.MuiTypography-root.gallerytitle{
    font-size: 20px;
    font-weight: 400;
    font-family: var(--font-family-primary);
    color: #E4E5ED;
}
.MuiBox-root.gallery-header{
    display: flex;
    align-items: center;
    gap: 10px;
}
.MuiBox-root.containerGallery{
    display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 30px;
}
.MuiDialogTitle-root.gallery-header-title{
    padding: 10px 0px;
}
.MuiFormControlLabel-root .MuiTypography-root{
    color: #fff;
}
.MuiBox-root.promptcontainer{
    background-color: #292B49;
    padding: 20px ;
    border-radius: 8px;
    margin-top: 20px;
     height: calc(100dvh - 229px);

}
.MuiBox-root.promptDetails{
    background-color: #303058;
     padding: 20px ;
     border-radius: 8px;
     height: 100%;
}
.MuiBox-root.promptButton{
    width: 100%;
    margin-top: 20px;
}
.MuiBox-root.promptButton .MuiButtonBase-root{
    width: 100%;
}
.MuiGrid-root.gallery-grid-item{
    cursor: pointer;
}
.MuiGrid-root.gallery-grid-item:hover{
    transform: scale(1.02);
    transition: transform 0.2s ease-in-out;
}
.MuiBox-root.zoom-in:hover{
     transform: scale(1.02);
    transition: transform 0.2s ease-in-out;
}
.MuiBox-root.gallery-title-container{
    cursor: pointer;
}
.MuiTypography-root.signinText{
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 600;
    font-family: var(--font-family-primary);
    margin-bottom: 11px;
}

@media screen and (max-width: 460px) {
.MuiBox-root.ImageContainers{
    height: auto;
}    
}`, "",{"version":3,"sources":["webpack://./src/components/Popup/Popup.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA,qCAAqC;AACrC;IACI,gCAAgC;AACpC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,uBAAuB;IAC3B;AACJ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;QACQ,yBAAyB;QACzB,kBAAkB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;AAClB;AACA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;GACG,6BAA6B;GAC7B,eAAe;IACd,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA,eAAe;AACf;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;KACf,4BAA4B;;AAEjC;AACA;IACI,yBAAyB;KACxB,cAAc;KACd,kBAAkB;KAClB,YAAY;AACjB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,sCAAsC;AAC1C;AACA;KACK,sBAAsB;IACvB,sCAAsC;AAC1C;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;AACA;IACI,YAAY;AAChB;AACA","sourcesContent":[".MuiDialog-root.PopupContainer .MuiDialog-container .MuiPaper-root {\n    background-color: #2D3055;\n    padding: 30px 40px 30px 30px;\n    width: 100%;\n    border-radius: 8px;\n}\n.MuiDialog-root.signinPopup .MuiDialog-container .MuiPaper-root {\n    background: linear-gradient(135deg, #2D3055 0%, #252847 100%);\n    border-radius: 12px;\n    max-width: 400px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n    overflow: visible;\n}\n \n/* Optional: Add a subtle animation */\n.MuiDialog-root.signinPopup .MuiDialog-container .MuiPaper-root {\n    animation: slideIn 0.3s ease-out;\n}\n \n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n    to {\n        opacity: 1;\n        transform: translate(0);\n    }\n}\n\n.MuiDialog-root.PopupContainerGallery .MuiDialog-container > .MuiPaper-root {\n  background-color: #2D3055;\n  padding: 10px 0px;\n  max-width: 80%;\n  border-radius: 8px;\n  height: 100%;\n}\n.aiInfluncerContainer{\n        background-color: #292B49;\n        border-radius: 8px;\n}   \n\n.MuiBox-root.PopupContent {\n    display: flex;\n    gap: 10px;\n    flex-direction: column;\n    width: 100%;\n}\n\n.MuiBox-root.PopupContentLeft {\n    background-color: #292B49;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 20px;\n    border-radius: 8px;\n    height: inherit;\n}\n\n.MuiBox-root.PopupContentLeftHeader {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    align-items: center;\n}\n\n.PopupContentLeftHeaderTitle {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.MuiTypography-root.PopupTitle {\n    font-size: 16px;\n    font-weight: 400;\n    font-family: var(--font-family-primary);\n    color: #E4E5ED;\n}\n.MuiPaper-root.model-cards{\n    width: 100%;\n    padding: 10px;\n}\n\n.MuiBox-root.PopupContentRight {\n    /* background-color: #292B49; */\n    height: 588px;\n    border-radius: 8px;\n}\n\n.MuiBox-root.PopupContentRight .MuiPaper-root {\n    padding: 0px !important;\n    background-color: #292B49 !important;\n}\n\n.MuiBox-root.PopupContentRightCard {\n    padding: 0px;\n}\n\n.MuiBox-root.videoWrappers {\n    width: 100%;\n    height: 100%;\n}\n.MuiBox-root.ImageContainers{\n    height: 200px;\n    width: 100%;\n}\n\n.videoPlayer {\n    height: 478px;\n}\n\n.videoPlayer {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.videoCard {\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.MuiBox-root.videoHeader {\n    position: absolute;\n    top: 8px;\n    right: 4%;\n}\n.MuiBox-root.viewHeader{\n    position: absolute;\n    top: 0;\n    right: 8%;\n    z-index: 1;\n}\n.MuiBox-root.shareHeader{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    z-index: 1;\n}\n.MuiBox-root.PopupHeader{\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n.PromptImage{\n    /* width: 73%; */\n    height: 100%;\n    object-fit: contain;\n    border-radius: 8px;\n    cursor: pointer;\n}\n.outPutImage{\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 8px;\n    cursor: pointer;\n}\n.fullImage{\n    width: 100%;\n    height: auto;\n    max-height: 80vh;\n    display: block;\n    margin: auto;\n    object-fit: contain;\n}\n.MuiButtonBase-root.CloseButton{\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    z-index: 1;\n}\n.MuiButtonBase-root.MuiCheckbox-root.selectionCheckbox{\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  border-radius: 50%;\n  background-color: transparent;\n}\n.MuiBox-root.width100{\n    width: 100%;\n}\n.MuiBox-root.endButton{\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 10px;\n}\n.silderImage{\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 8px;\n    background-color: #2D3055;\n}\n.MuiTypography-root.confirmTitle{\n    font-size: 20px;\n    font-weight: 400;\n    font-family: var(--font-family-primary);\n    color: #fff;\n}\n.MuiTypography-root.confirmDescription{\n    font-size: 16px;\n    font-weight: 400;\n    font-family: var(--font-family-primary);\n    color: #fff;\n    margin-top: 10px;\n}\n.AudioPlayer.rhap_container{\n    background-color: transparent;\n}\n.AudioPlayer>.rhap_main>.rhap_progress-section>.rhap_current-time{\n    color: #fff;\n}\n.AudioPlayer>.rhap_main>.rhap_progress-section>.rhap_time {\n    color: #fff;\n}\n.AudioPlayer>.rhap_main>.rhap_progress-section>.rhap_progress-container>.rhap_progress-bar{\n    color: #fff;\n}\n.AudioPlayer>.rhap_main>.rhap_progress-section>.rhap_progress-container>.rhap_progress-bar>.rhap_progress-indicator{\n    background-color: #692AA5;\n    box-shadow: none;\n}\n.AudioPlayer>.rhap_main>.rhap_progress-section>.rhap_progress-container>.rhap_progress-bar>.rhap_progress-filled{\n    background-color: #692AA5;\n}\n.AudioPlayer>.rhap_main>.rhap_controls-section>.rhap_additional-controls{\n    display: none;\n}\n.AudioPlayer>.rhap_main>.rhap_controls-section{\n    display: block;\n}\n.AudioPlayer>.rhap_main>.rhap_controls-section>.rhap_main-controls>.rhap_button-clear{\n   background-color: transparent;\n   font-size: 30px;\n    width: 30px;\n    height: 30px;\n}\n.AudioPlayer>.rhap_main>.rhap_controls-section>.rhap_volume-controls{\n    display: none;\n}\n/* Responsive */\n@media screen and (min-width: 768px) {\n    .MuiBox-root.PopupContent {\n        flex-direction: row;\n    }\n}\n\n/* galaerypage */\n.MuiDialogContent-root.card-gallery-content{\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    justify-content: center;\n}\n.MuiTypography-root.gallerytitle{\n    font-size: 20px;\n    font-weight: 400;\n    font-family: var(--font-family-primary);\n    color: #E4E5ED;\n}\n.MuiBox-root.gallery-header{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.MuiBox-root.containerGallery{\n    display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 30px;\n}\n.MuiDialogTitle-root.gallery-header-title{\n    padding: 10px 0px;\n}\n.MuiFormControlLabel-root .MuiTypography-root{\n    color: #fff;\n}\n.MuiBox-root.promptcontainer{\n    background-color: #292B49;\n    padding: 20px ;\n    border-radius: 8px;\n    margin-top: 20px;\n     height: calc(100dvh - 229px);\n\n}\n.MuiBox-root.promptDetails{\n    background-color: #303058;\n     padding: 20px ;\n     border-radius: 8px;\n     height: 100%;\n}\n.MuiBox-root.promptButton{\n    width: 100%;\n    margin-top: 20px;\n}\n.MuiBox-root.promptButton .MuiButtonBase-root{\n    width: 100%;\n}\n.MuiGrid-root.gallery-grid-item{\n    cursor: pointer;\n}\n.MuiGrid-root.gallery-grid-item:hover{\n    transform: scale(1.02);\n    transition: transform 0.2s ease-in-out;\n}\n.MuiBox-root.zoom-in:hover{\n     transform: scale(1.02);\n    transition: transform 0.2s ease-in-out;\n}\n.MuiBox-root.gallery-title-container{\n    cursor: pointer;\n}\n.MuiTypography-root.signinText{\n    color: #FFFFFF;\n    font-size: 20px;\n    font-weight: 600;\n    font-family: var(--font-family-primary);\n    margin-bottom: 11px;\n}\n\n@media screen and (max-width: 460px) {\n.MuiBox-root.ImageContainers{\n    height: auto;\n}    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
